"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgMoreCircle = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 12C0 5.373 5.373 0 12 0c6.624.007 11.993 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12zm6.5 2a2 2 0 100-4 2 2 0 000 4zm5.5-4a2 2 0 110 4 2 2 0 010-4zm3.5 2a2 2 0 104 0 2 2 0 00-4 0z", clipRule: "evenodd" })));
};
exports.default = SvgMoreCircle;
//# sourceMappingURL=MoreCircle.js.map